<template>
    <!-- 登录 -->
    <div class="box" style="min-width: 1600px;">
        <NavBar navIndex="7"></NavBar>
        <div style="padding:30px;"></div>
        <div style="position:relative;width: 100%;">
            <img style="display: block;width: 100%;" src="../assets/dynamic-bg.png" alt="">
            <div style="position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);font-size:38px;font-weight: bold;text-align: center;color: #fff;">
                弘知动态
                <div class="content-title-border"></div>
            </div>
        </div>
    
        <div style="background-color: #fff;padding: 50px 0;">
            <div style="width: 1200px;margin:0 auto;display: flex;flex-wrap: wrap;">
                <!-- 新闻列表单元格 -->
                <div v-for="(item,index) in dynamicListData" class="dynamic-list-box" @click="goDynamicDetail(item)">
                    <div class="dynamic-list-time" >
                        <div style="color: #999999;">{{item.time}}</div>
                        <div class="dynamic-day" >{{item.day}}</div>
                    </div>

                    <div class="dynamic-content-box"  :style="{border:(index === dynamicListData.length - 1)?'none':''}">

                        <div style="margin: 0px 50px 0px 0;">
                            <div class="dynamic-content-title" >
                                {{item.dynamicName}}
                            </div>
                            <p style="color: #666666;margin-top: 15px;line-height: 28px;-webkit-box-orient: vertical;text-overflow: ellipsis;
                            overflow: hidden;
                            display: -webkit-box;
                            line-clamp: 2; 
                            height: 60px;word-break: break-all;">
                                {{item.dynamicTwo}}
                        </p>
                        </div>

                        <div class="click-box" >
                            <img class="click-img"  src="../assets/click-img.png" alt="">
                            <img class="click-img-null"  src="../assets/click-img-null.png" alt="">
                        </div>
                    </div>
                </div>

                
                
            </div>
            <div class="pagination-block">
                <el-pagination 
                    @current-change="changepagination"
                    layout="prev, pager, next"
                    :page-size="6"
                    :total="total">
                </el-pagination>
            </div>
    
            
        </div>
    
        
    
        <Footer></Footer>
    </div>
    </template>
    
    <script>
    import NavBar from '@/components/navBar.vue'
    import Footer from '@/components/Footer.vue'
    import { dynamicList } from "@/request/api"
    
    export default {
        name: 'dynamic',
        components: {
            NavBar,
            Footer
        },
        data() {
            return {
                page_control: "1",
                jobData: [],
                total: 6,
                jobContent: {},//工作信息详情
                dynamicListData: [],
            };
        },
        mounted(){
            let that = this
            dynamicList(
                "pageNum=1&pageSize=6"
            ).then(res=>{
                console.log("动态",res.data.result)
                let data = res.data.result
                data.forEach(function(res,index){
                    res.time = res.insertDate.slice(0,7)
                    res.day = res.insertDate.slice(8,10)
                })
                that.dynamicListData = data
                that.total = res.data.total
                console.log(data)
            })
        },
        methods: {
            lookJob(e){
                let that = this
                that.page_control = "2"
                console.log(e)
                this.jobContent = e
            },
            showJob(){
                this.page_control = "1"
            },
            goHome(){
                this.$router.push('/')
            },
            changepagination(e){
                console.log(e)
                let that = this
                dynamicList(
                    "pageSize=6&pageNum=" + e
                ).then(res=>{
                    console.log("招聘",res.data.result)
                    let data = res.data.result
                    data.forEach(function(res,index){
                        res.time = res.insertDate.slice(0,7)
                        res.day = res.insertDate.slice(8,10)
                    })
                    that.dynamicListData = data
                })
            },
            goDynamicDetail(e){
                console.log("e",e)
                this.$router.push({name:'dynamic_detail',query: {dynamicId: e.dynamicId}})
            }
    
        }
    }
    </script>
    
    <style scoped>
    .content-title-border {
        position:absolute;
        width: 32px;
        height:4px;
        background-color: #fff;
        left: 50%;
        transform: translateX(-50%);
        bottom: -15%;
    }
    .job-cell {
        width: 31%;
        background-color: #fff;
        padding:30px;
        box-sizing: border-box;
        margin: 10px;
        cursor:pointer
    }
    .job-cell:hover {
        box-shadow: 0 0 8px 5px #EAEAEA;
    }
    
    .teacher-classify {
        position:relative;
        font-size:26px;
        font-weight: bold;
        width: 70%;
        margin-bottom: 25px;
    }
    .teacher-classify-border {
        position:absolute;
        width: 32px;
        height:2px;
        background-color: #0050A7;
        bottom: -25%;
    }
    
    /* 分页 */
    .pagination-block {
        text-align: center;
        margin: 30px;
    }

    /* 动态列表 */
    .dynamic-list-box {
        display: flex;
        align-items: center;
    }
    .dynamic-list-time {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        text-align: center;
        border: 1px solid #DEDEDE;
    }
    .dynamic-day {
        font-size: 36px;
        color: #0053AD;
        font-weight: bold;
        margin-top: 5px;
    }
    .dynamic-content-box {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #D8D8D8;
        padding: 40px 15px 40px 0;
        margin-left: 30px;cursor:pointer
    }
    .dynamic-content-title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
    }
    .dynamic-content-box:hover .dynamic-content-title{
        color: #0053AD;
    }
    .click-box {
        width: 40px;
        position: relative;
        min-height: 20px;
        flex-shrink: 0;
    }
    .click-img {
        width: 40px;
        position: absolute;
        z-index: 1;
    }
    .click-img-null {
        width: 40px;
        position: absolute;
        z-index: 2;
        background-color: #fff;
    }
    .dynamic-content-box:hover .click-img{
        z-index: 2;
    }
    .dynamic-content-box:hover .click-img-null{
        z-index: 1;
    }
    </style>
            